import React from "react";
import "./LegalPages.css";

const AboutUs = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>About Us</h1>

        <section>
          <h2>Who We Are</h2>
          <p>
            Variant Exclusive is a design-led studio specializing in custom
            3D-printed products. We combine precision manufacturing with
            personalization, turning your ideas into physical, one-of-a-kind
            pieces — from home decor and accessories to bespoke gifts and
            functional prints.
          </p>
        </section>

        <section>
          <h2>What We Do</h2>
          <p>
            Every product on Variant Exclusive is made to order using
            modern 3D-printing technology. Whether you're customizing an
            existing design or working with us on something entirely new,
            we focus on quality finishes, durable materials, and fast,
            reliable production.
          </p>
        </section>

        <section>
          <h2>Why Variant Exclusive</h2>
          <ul>
            <li>
              <strong>Made to order:</strong> Every piece is printed
              specifically for you — no mass production, no generic stock.
            </li>
            <li>
              <strong>Quality first:</strong> We use tested materials and
              finishing processes for durable, presentable results.
            </li>
            <li>
              <strong>Secure checkout:</strong> Payments are handled
              securely through Cashfree, with support for major cards, UPI,
              and net banking.
            </li>
            <li>
              <strong>Direct support:</strong> Questions about an order or a
              custom request? You're talking to the people who actually
              make your product, not a call center.
            </li>
          </ul>
        </section>

        <section>
          <h2>Our Process</h2>
          <p>
            You choose or customize a design, we review the specifications,
            print your order with care, and ship it directly to your door.
            We keep you updated at every stage — from order confirmation to
            dispatch.
          </p>
        </section>

        <section>
          <h2>Get in Touch</h2>
          <p>
            Have a custom idea, a bulk order request, or just a question?
            Reach out at{" "}
            <a href="mailto:variantexclusive@gmail.com">
              variantexclusive@gmail.com
            </a>{" "}
            — we'd love to help bring it to life.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
